import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditDG = (props) => {
  const [value, setValue] = useState(props.client.dzial_gosp);
  const [valueAdd, setValueAdd] = useState(props.client.dzial_gosp_add);
  const [loading, setLoading] = useState(false);
  const [dgOptions, setDGOptions] = useState([]);
  const [addOptions, setAddOptions] = useState([]);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        dzial_gosp: value,
        dzial_gosp_add: valueAdd,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addDGClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o działalności gospodarczej",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "TAK", value: "TAK" });
    statusOptions.push({ label: "NIE", value: "NIE" });
    statusOptions.push({ label: "Brak danych", value: "Brak danych" });

    return statusOptions;
  };

  const createAddOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({
      label: "opisana w pozwie",
      value: "opisana w pozwie",
    });
    statusOptions.push({
      label: "nieopisana w pozwie",
      value: "nieopisana w pozwie",
    });
    statusOptions.push({
      label: "podniesiona w odpowiedzi na pozew",
      value: "podniesiona w odpowiedzi na pozew",
    });
    statusOptions.push({
      label: "niepodniesiona w odpowiedzi na pozew, ale we wniosku kredytowym",
      value: "niepodniesiona w odpowiedzi na pozew, ale we wniosku kredytowym",
    });

    return statusOptions;
  };

  useEffect(() => {
    setDGOptions(createYesNoOptions());
    setAddOptions(createAddOptions());
  }, []);

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje o sprawie</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Działalność gospodarcza <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={dgOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>

          {value === "TAK" ? (
            <>
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>
                    + <span className="requiredStar">*</span>
                  </label>
                  <Select
                    noOptionsMessage={() => "Brak danych"}
                    placeholder={"Wybierz..."}
                    isClearable={false}
                    options={addOptions}
                    onChange={(e) => setValueAdd(e.value)}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditDG;
